var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0659 16.4102C24.0282 16.4102 19.1328 21.3056 19.1328 27.3432C19.1328 33.3809 24.0282 38.2763 30.0659 38.2763C36.1035 38.2763 40.9989 33.3817 40.9989 27.3432C40.9989 21.3047 36.1035 16.4102 30.0659 16.4102Z",
    fill: "#403C6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0031 43.7432H19.1362C13.0985 43.7432 8.20312 48.6394 8.20312 54.677V65.6101H51.9362V61.0033C45.4852 57.9251 41.0031 51.356 41.0031 43.7432Z",
    fill: "#403C6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1349 30.0771C52.5868 30.0771 46.4688 36.1952 46.4688 43.7441C46.4688 51.2922 52.5868 57.4102 60.1349 57.4102C67.6838 57.4102 73.8018 51.2922 73.8018 43.7433C73.8018 36.1943 67.6838 30.0771 60.1349 30.0771ZM67.3853 48.0917L64.4866 50.9904L60.1349 46.642L55.7897 50.9904L52.8852 48.0917L57.2362 43.7433L52.8852 39.3956L55.7897 36.4969L60.1349 40.8454L64.4866 36.4969L67.3853 39.3956L63.0336 43.7433L67.3853 48.0917Z",
    fill: "#403C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRoleIcon);
export default __webpack_public_path__ + "static/media/no-role-icon.be55db5d4c6881119e91809f2365e3d1.svg";
export { ForwardRef as ReactComponent };